import type { DrawerConfig } from '../configuration';
import type {
  ChallengeData,
  ChallengesDrawer as ChallengesDrawerProp,
} from '../types';
import { ChallengeDrawerBody } from './ChallengeDrawerBody';
import { ChallengeDrawerHeader } from './ChallengeDrawerHeader';
import { ChallengesDrawerOverflowCard } from './ChallengesDrawerOverflowCard';
import { ChallengesDrawer } from './index';

export const challengesDrawerConfiguration = {
  drawer: ChallengesDrawer,
  body: ChallengeDrawerBody,
  allowMultipleInstance: false,
  header: ChallengeDrawerHeader,
  overflowCard: ChallengesDrawerOverflowCard,
  shouldConfirmOnClose: () => {
    return false;
  },
  getId: (data) => {
    return data.challengeId;
  },
  onClose: (props) => {
    if ('onClose' in props.data && props.data.onClose) {
      props.data.onClose();
    }
  },
} satisfies DrawerConfig<ChallengesDrawerProp, ChallengeData>;
